module.exports = __webpack_public_path__ + "static/media/memories_7.76cde1fb.jpg";